import EventEmitter from '@/utils/EventEmitter'
import { concantQuery } from '@/utils/concatQuery'
import api from './api'

const UserEventEmitter = new EventEmitter()

const wsEvents = {
  USER_UPDATE_NOTITIFICATIONS: 'USER_UPDATE_NOTITIFICATIONS',
  notifications: 'notifications'
}

/**
 * Listen websocket event
 * Example: wsListeners[wsEvents.SOME_EVENT](callback)
*/
const wsListeners = (() => {
  const listeners = Object.keys(wsEvents)
    .reduce((acc, eventName) => {
      acc[eventName] = (fn) => UserEventEmitter.on(eventName, fn)
      return acc
    }, {})

  return listeners
})()

const wrapAction = (action) => {
  if (!wsActions.socket) {
    UserEventEmitter.on('connect', action)
  } else {
    action()
  }
}

const wsActions = {
  socket: null,
  ACTION_READ_NOTIFICATION: ({ ids }) => {
    wrapAction(() => wsActions.socket.emit('ACTION_READ_NOTIFICATION', { ids }))
  }
}

/**
 *
 * @param {Socket} socket
 */
function bindWsEvents (socket) {
  wsActions.socket = socket

  Object.keys(wsEvents).forEach(eventName => {
    socket.on(eventName, (args) => UserEventEmitter.emit(eventName, args))
  })
}

/* --- POST --- */
/**
 * Create user.
 * @param {Object} user
 * @param {string} user.email
 * @param {string} user.username
 * @param {string} [user.phoneNumber]
 * @returns {Promise}
 */
async function add ({ user, subscribeToDailyMail, token }) {
  return await api.post('/user/admin', { ...user, subscribeToDailyMail, token })
}

/**
 * Change user password.
 * @param {string} password    - Current user password.
 * @param {string} newPassword - New user password.
 * @returns {Promise}
 */
async function changePassword ({ newPassword, password }) {
  return await api.post('/user/change-password', { newPassword, password })
}

/**
 * Upload user photo.
 * @param {FormData} formData    - Current user password.
 * @returns {Promise}
 */
async function uploadUserPhoto ({ formData, toUserId }) {
  const query = concantQuery({ toUserId })
  return await api.post(`/user/upload-avatar${query}`, formData)
}

/**
 * Get user avatars.
 * @param {object} param0
 * @param {string[]} param0.usernames
 * @returns {Promise<string[]>}
 */
async function getUsersAvatar({ usernames }) {
  return await api.post('/user/avatar', { usernames })
}

/* --- PUT --- */
/**
 * Edit user.
 * @param {Object} user              - User's info.
 * @param {string} user.email        - User's email.
 * @param {string} user.username     - User's username.
 * @param {string} user.phoneNumber  - User's phone number.
 * @param {string} user.bio          - User's biography.
 * @returns {Promise}
 */
async function editProfile ({ user, toUserId }) {
  const query = concantQuery({ toUserId })
  return await api.put(`/user/${query}`, user)
}

/**
 * Get notifications.
 * @param {object} params - query params
 * @returns
*/
const getUserNotifications = () => {
  return api.get('/notification')
}

export {
  bindWsEvents,
  wsActions,
  wsEvents,
  wsListeners,
  add,
  editProfile,
  changePassword,
  uploadUserPhoto,
  getUserNotifications,
  getUsersAvatar
}
